import { getFixedValue, convert } from "./currencyConvertion";

export const getServiceFeeValue = ({ serviceFees, totalWithoutServiceFee, base, rates, currency }) => {
    try {
        let guestServiceFee = 0, hostServiceFee = 0, guestServiceFeeType = '', hostServiceFeeType = '', guestServiceFeeValue = 0, hostServiceFeeValue;

        let normalizedFees = serviceFees;

        if (Array.isArray(serviceFees) && serviceFees.length > 0) {
            normalizedFees = {
                guest: {
                    type: serviceFees[0].guestType,
                    value: serviceFees[0].guestValue,
                    currency: serviceFees[0].currency
                },
                host: {
                    type: serviceFees[0].hostType,
                    value: serviceFees[0].hostValue,
                    currency: serviceFees[0].currency
                }
            };
        }

        if (normalizedFees?.guest) {
            guestServiceFeeType = normalizedFees?.guest?.type;
            guestServiceFeeValue = normalizedFees?.guest?.value;
            guestServiceFee = normalizedFees?.guest?.type === 'percentage'
                ? Math.ceil(totalWithoutServiceFee * (Number(normalizedFees.guest.value) / 100))
                : getFixedValue(convert(base, rates, normalizedFees.guest.value, normalizedFees.guest.currency, currency));
        }

        if (normalizedFees?.host) {
            hostServiceFeeType = normalizedFees?.host?.type;
            hostServiceFeeValue = normalizedFees?.host?.value;
            hostServiceFee = normalizedFees.host.type === 'percentage'
                ? Math.ceil(totalWithoutServiceFee * (Number(normalizedFees.host.value) / 100))
                : getFixedValue(convert(base, rates, normalizedFees.host.value, normalizedFees.host.currency, currency));
        }

        return { guestServiceFee, hostServiceFee, hostServiceFeeType, guestServiceFeeType, guestServiceFeeValue, hostServiceFeeValue };
    } catch (error) {
        return { guestServiceFee: 0, hostServiceFee: 0, hostServiceFeeType: '', guestServiceFeeType: '', guestServiceFeeValue: 0, hostServiceFeeValue: 0 };
    }
};